import { createContext, useEffect, useState, useRef } from "react";
import * as signalR from '@microsoft/signalr';

export const TwoFAContext = createContext();

export const TwoFAProvider = ({ children }) => {
    const connectionRef = useRef(null);

    const [isEgnValid, setIsEgnValid] = useState(null);
    const [toggleCallFunction, setToggleCallFunction] = useState(false);


    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_BACKEND_URL == 'api/' ? "/TwoFAHub" : 'https://localhost:7127/TwoFAHub')
            .build();

        connection.start()
            .then(() => {
                console.log('Connection established.');
                connectionRef.current = connection;
            })
            .catch(error => {
                console.error('Error establishing connection:', error);
            });


        connection.on("ReceiveCheckUserEgn", (isValid) => {
            setIsEgnValid(isValid);
            setToggleCallFunction(state => !state)
        });

        return () => {
            if (connectionRef.current) {
                connectionRef.current.stop()
                    .then(() => {
                        setIsEgnValid(false);
                        console.log('Connection closed.');
                    })
                    .catch(error => {
                        console.error('Error while closing connection:', error);
                    });
            }
        };
    }, [])

    const checkUserEgnInDb = (username, egn, isInAdmin) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("CheckUserEgn", username, egn, isInAdmin)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    return (
        <TwoFAContext.Provider value={{ isEgnValid, checkUserEgnInDb, toggleCallFunction }}>
            {children}
        </TwoFAContext.Provider>
    )
}